import { useQuery } from '@tanstack/react-query';
import { getWorkItemDetails, getWorkItemHistory, getWorkItemChildren } from '../api/workItem';
import { WorkItemDetailsResponse, WorkItemHistory } from '../../../types/task';
import { GetTasksSuccessResponse } from '../../../types/project/tasks';

export const useWorkItemChildrenQuery = (
  projectUuid?: string,
  workItemUuid?: string,
  childCursor: string | null = null,
  size: number = 20,
  options?: any
) => {
  return useQuery<any>({
    ...options,
    queryKey: ['task-children', projectUuid, workItemUuid, childCursor, size],
    queryFn: () => getWorkItemChildren(projectUuid!, workItemUuid!, childCursor, size),
    enabled: Boolean(projectUuid && workItemUuid),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });
};

export const useTaskDetailsQuery = (
  projectUuid?: string,
  workItemUuid?: string,
  childPage: number = 0,
  childSize: number = 0,
  includeChildren: boolean = false,
  options?: any
) => {
  return useQuery<WorkItemDetailsResponse>({
    ...options,
    // Unique query key that includes both IDs for proper caching
    queryKey: ['task', projectUuid, workItemUuid, childPage, childSize, includeChildren],
    
    // The function that fetches the data
    queryFn: () => getWorkItemDetails(projectUuid!, workItemUuid!, childPage, childSize, includeChildren),

    // CRITICAL: Only run this query if we have BOTH IDs (i.e., we are in Edit Mode)
    enabled: Boolean(projectUuid && workItemUuid),

    // Optional: Keep the data fresh, but don't spam the API on every tiny focus
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });
};

export const useWorkItemHistoryQuery = (
  projectUuid?: string,
  workItemUuid?: string,
) => {
  return useQuery<WorkItemHistory[]>({
    queryKey: ['task-history', projectUuid, workItemUuid],
    queryFn: () => getWorkItemHistory(projectUuid!, workItemUuid!),
    enabled: Boolean(projectUuid && workItemUuid),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
